<div class="app-form-events-modal">
  <div class="modal-header">
    <h3 class="modal-title m-0">{{ title }}</h3>
  </div>
  <div class="modal-body">
    @for (field of mappedFieldToFormItems$(); track $index) {
      <div class="row">
        <div class="col-md-12 app-form-events-modal__body__col">
          <app-office-form-control [formGroupInstance]="eventsForm" [officeField]="field"></app-office-form-control>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button appButton="outline-secondary" (click)="close()">Close</button>
    <button appButton="primary" (click)="confirm()">Ok</button>
  </div>
</div>
